import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { UpdateExpiryCardForm } from '@/components/UpdateExpiryCardForm';
import { useRootNavigation } from '@/hooks/use-root-navigation';
import { WithdrawStackParamList } from '@/navigation/types';
import { WithdrawalExpiryUpdateNavigationProp } from '@/navigation/withdraw/types';

type WithdrawalExpiryUpdateProps = NativeStackScreenProps<WithdrawStackParamList, 'WithdrawalExpiryUpdate'>;

export const WithdrawalExpiryUpdate = ({ route }: WithdrawalExpiryUpdateProps) => {
    const { selectedMethod, methods } = route.params;
    const navigation = useNavigation<WithdrawalExpiryUpdateNavigationProp>();
    const rootNavigation = useRootNavigation();
    const { t } = useTranslation(['wallet', 'common']);

    const secondaryButtonLabel = t('withdrawal_update_expiry_card_form_secondary_label');

    const onSuccessUpdateCard = () => {
        navigation.navigate('WithdrawForm', {
            selectedMethod,
            methods,
        });
    };

    const onErrorUpdateCard = () => {
        navigation.navigate('ErrorModal', {
            title: t('update_expiry_card_error_title'),
            subtitle: t('update_expiry_card_error_subtitle'),
            primaryButton: t('common:review_information'),
            showSecondaryButton: true,
            secondaryButton: secondaryButtonLabel,
            handleSecondaryButtonPress: () => {
                // from the root, so the error modal closes and we go back to the method list in the withdraw stack
                rootNavigation.navigate(
                    'WithdrawStack',
                    { screen: 'ChooseWithdrawalMethod', pop: true },
                    { pop: true }
                );
            },
            closeIconMode: 'close',
        });
    };

    const onPressSecondaryButton = () => {
        navigation.popTo('ChooseWithdrawalMethod');
    };

    const paymentTypeId = selectedMethod.payment_type_id;

    return (
        <UpdateExpiryCardForm
            {...{ paymentTypeId, onSuccessUpdateCard, onErrorUpdateCard, onPressSecondaryButton, secondaryButtonLabel }}
        />
    );
};
